import React, { useState } from 'react';
import { connect } from 'react-redux';
import lodash from 'lodash';
import SideNavItem from './SideNavItem';
import SideNavSearch, { flattenNavItems, filterNavItems } from './SideNavSearch';
import sideNavItemList, { sideNavLinkType } from './config';
import UserInfoSidebarBottom from './UserInfoSidebarBottom';


// Styling is located in:
//    src/assets/scss/3-components/_sidebar.scss
//    src/assets/scss/upward/_sidebar.scss
const parseSideNavItem = (sideNavItem = {}) => {
   const activePathList = [];

   if (lodash.isObject(sideNavItem)) {
      const { path = null, subItems = [] } = sideNavItem;

      if (lodash.isString(path)) {
         if (path.indexOf('?') !== -1) {
            activePathList.push(path.substr(0, path.indexOf('?')).toLowerCase());
         } else {
            activePathList.push(path.toLowerCase());
         }
      }

      for (let i = 0; i < subItems.length; ++i) {
         activePathList.push(...parseSideNavItem(subItems[i]));
      }
      sideNavItem.activePathList = activePathList;
   }

   return activePathList;
};

const parseSideNavItemList = (sideNavItemListArg = []) => {
   for (let i = 0; i < sideNavItemListArg.length; ++i) {
      parseSideNavItem(sideNavItemListArg[i]);
   }
   return sideNavItemListArg;
};

const parsedSideNavItemList = parseSideNavItemList(sideNavItemList);

const flatNavItems = flattenNavItems(sideNavItemList);

const SideNav = (props) => {
   const [selfDelta, setSelfDelta] = useState();
   const [searchQuery, setSearchQuery] = useState('');

   const sectionHasAccess = (type) => {
      if (type === sideNavLinkType.employer) {
         return props.isLoggedInAsEmployer && !props.isImpersonatingPartner;
      }
      if (type === sideNavLinkType.partner) {
         return props.isLoggedInAsPartner && !props.isImpersonatingEmployer;
      }
      if (type === sideNavLinkType.admin) {
         return !props.isImpersonatingEmployer && !props.isImpersonatingPartner;
      }
      return false;
   };

   const searchResults = filterNavItems(flatNavItems, searchQuery)
      .filter((item) => sectionHasAccess(item.type));

   return (
      <nav
         className={
            `sidebar ${ !props?.sidebar?.isOpen ? '' : 'toggled' } ${ props?.sidebar?.isSticky ? ' sidebar-sticky' : '' }`
         }
      >
         <div className='sidebar-content'>
            {
               /*
                * LUT-510: native scrolling instead of react-perfect-scrollbar. PerfectScrollbar
                * requires explicit update() calls whenever content height changes; expanding or
                * collapsing nav sections left its rail/thumb sized from stale measurements (rail
                * ending partway down the nav). Native overflow-y always tracks content. Thin
                * scrollbar styling lives in 3-components/_sidebar.scss (.sidebar-scroll).
                */
            }
            <div className='sidebar-scroll'>
               <ul className='sidebar-nav'>
                  <SideNavSearch query={ searchQuery } onQueryChange={ setSearchQuery }/>
                  {
                     searchQuery.trim()
                        ? searchResults.map((item) => (
                           <SideNavItem
                              key={ `search-${ item.path }` }
                              name={ item.trail ? `${ item.name }  ·  ${ item.trail }` : item.name }
                              path={ item.path }
                              access={ item.access }
                              deprecating={ item.deprecating }
                              deprecatingText={ item.deprecatingText }
                              ported={ item.ported }
                              isComingSoon={ item.isComingSoon }
                              level={ 0 }
                              activePathList={ [item.path.toLowerCase()] }
                           />
                        ))
                        : parsedSideNavItemList.map((sidebarItem) => {
                           const { type } = sidebarItem;
                           const sideNavComponent = (
                              <SideNavItem
                                 setParentDelta={ setSelfDelta }
                                 parentDelta={ selfDelta }
                                 { ...sidebarItem }
                                 key={ `${ sidebarItem?.name }-${ sidebarItem?.location }` }
                                 level={ 0 }
                                 activePathList={sidebarItem?.activePathList}
                              />
                           );

                           let hasAccess = false;
                           if (type === sideNavLinkType.employer && props.isLoggedInAsEmployer && !props.isImpersonatingPartner) {
                              hasAccess = true;
                           } else if (type === sideNavLinkType.partner && props.isLoggedInAsPartner && !props.isImpersonatingEmployer) {
                              hasAccess = true;
                           } else if (type === sideNavLinkType.admin && !props.isImpersonatingEmployer && !props.isImpersonatingPartner) {
                              hasAccess = true;
                           }
                           return hasAccess ? sideNavComponent : null;
                        })
                  }
               </ul>
            </div>
         </div>
         <UserInfoSidebarBottom/>
      </nav>
   );
};

export default connect((store) => ({
   sidebar: store.sidebar,
   layout: store.layout,
   isLoggedInAsEmployer: store.authReducer.isLoggedIn,
   isLoggedInAsPartner: store.authReducer.isLoggedInPartner,
   isImpersonatingEmployer: store.authReducer?.loggedInUser?.impersonating === 'true',
   isImpersonatingPartner: store.authReducer?.loggedInUserPartner?.impersonating,
}))(SideNav);
